import { render, staticRenderFns } from "./ContentUser.vue?vue&type=template&id=60d7a070&scoped=true&shadow"
import script from "./ContentUser.vue?vue&type=script&lang=js&shadow"
export * from "./ContentUser.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentUser.vue?vue&type=style&index=0&id=60d7a070&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "60d7a070",
  null
  ,true
)

export default component.exports